'use client';

import { IAttributesHeadSeo } from '@/repositories/aecomStrapiCms/headSeo/types';
import { TShowcases } from '@/repositories/aecomStrapiCms/showcase/types';
import strapiBannersHome from '../../../../../packages/promotions/src/repositories/aecomStrapiCms/bannerHome';
import { HomeV2BannerHybrid } from './components/BannerHybrid';
import { HomeV2TopicIconsGroup } from './components/TopicIconsGroup';
import { HomeV2PopularCategories } from './components/PopularCategories';
import { HomeV2Newsletter } from './components/Newsletter';
import { HomeV2SEO } from './components/SEO';
import { Container, Main, Section } from './styles';
import { Showcases } from './components/Showcases';

interface HomeScreenV2Props {
  homeShowcases: TShowcases[];
  seoData: IAttributesHeadSeo;
}

export function HomeScreenV2({ homeShowcases, seoData }: HomeScreenV2Props) {
  const auth = {
    baseUrl: process.env.BFF_API_BASE_URL,
  };

  const { useBannersHome } = strapiBannersHome(auth);
  const { data: configBanner } = useBannersHome();

  const getHeroBannerAttributes = () => configBanner?.data?.hero?.attributes;
  const getHeroBannerId = () => configBanner?.data?.hero?.id ?? null;

  const getCommonBannerAttributes = () =>
    configBanner?.data?.common?.attributes;
  const getCommonBannerId = () => configBanner?.data?.common?.id ?? null;

  return (
    <Main>
      <Container>
        <Section className="hero-banner">
          <HomeV2BannerHybrid
            banner={getHeroBannerAttributes()}
            bannerId={getHeroBannerId()}
            isHeroBanner
          />
        </Section>

        <Section className="topic-icons-group">
          <HomeV2TopicIconsGroup />
        </Section>

        <Section className="popular-categories">
          <HomeV2PopularCategories />
        </Section>

        <Section className="showcases-hero">
          <Showcases showcases={homeShowcases} isHero />
        </Section>

        <Section className="common-banner">
          <HomeV2BannerHybrid
            banner={getCommonBannerAttributes()}
            bannerId={getCommonBannerId()}
          />
        </Section>

        <Section className="showcases-common">
          <Showcases showcases={homeShowcases} />
        </Section>

        <Section className="newsletter">
          <HomeV2Newsletter />
        </Section>

        <Section className="seo">
          <HomeV2SEO seoData={seoData} />
        </Section>
      </Container>
    </Main>
  );
}
